import { Box, Tabs } from '@tempmee/react';
import { OnsiteInterviewStatus, OnsiteInterviewStatusMapper } from '~/domain/PermanentJobs';

const TABS = [
  OnsiteInterviewStatus.ActionNeeded,
  OnsiteInterviewStatus.Open,
  OnsiteInterviewStatus.Scheduled,
  OnsiteInterviewStatus.Completed,
  OnsiteInterviewStatus.Cancelled,
];

interface IOnsiteInterviewStatusFilterPanelProps {
  counts: Record<OnsiteInterviewStatus, number> & { all: number };
  onChange(tab: OnsiteInterviewStatus | 'all'): void;
}

export const OnsiteInterviewStatusFilterPanel = ({
  counts,
  onChange,
}: IOnsiteInterviewStatusFilterPanelProps) => {
  return (
    <Tabs
      defaultValue="all"
      onValueChange={(value) => onChange(value === 'all' ? 'all' : (value as OnsiteInterviewStatus))}
      style={{ alignItems: 'flex-start' }}
    >
      <Tabs.List style={{ gap: 16, flexWrap: 'wrap' }}>
        <Tabs.Tab value="all" data-cy="onsite-interview-filter-tab-all">
          {`All Active${counts.all > 0 ? ` (${counts.all})` : ''}`}
        </Tabs.Tab>
        {TABS.map((it) => (
          <Tabs.Tab key={it} value={it} data-cy={`onsite-interview-filter-tab-${it}`}>
            <Box
              height="10px"
              width="10px"
              className="rounded-full"
              style={{
                display: 'inline-block',
                marginRight: 6,
                backgroundColor: OnsiteInterviewStatusMapper.getColor(it),
              }}
            />
            {`${OnsiteInterviewStatusMapper.toHumanReadable(it)}${counts[it] > 0 ? ` (${counts[it]})` : ''}`}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  );
};
